import React, { FC } from 'react'
import s from './QuickSearchOutput.module.sass'
import { Title } from '@shared/ui/Typography/Title'
import IconErr500 from '@pages/ServiceErr/IconErr500'

interface Props {
  mode: 'empty-picture' | 'empty-text' | 'error'
}

const QuickSearchOutputEmpty: FC<Props> = ({ mode }) => {
  return mode === 'empty-picture' ? (
    <div className={s['not-found-block']}>
      <IconErr500 />
      <Title tag='h4' sizes='h4'>
        Ничего не найдено
      </Title>
    </div>
  ) : (
    <span className={s['not-found']}>{mode === 'empty-text' ? 'Ничего не найдено' : 'Произошла ошибка'}</span>
  )
}

export default QuickSearchOutputEmpty
